import React,{useEffect, useRef, useState} from "react";
import { motion, AnimatePresence } from "framer-motion";
import BreadCrumb from "../Components/BreadCrumb";
import bgImg from '../Images/infrastructure-breadcrumb.webp';
import Cta from "../Components/Cta";
import Certificates from "../Components/Certificates";
import ContactSection from "../Components/ContactSection";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { efficiencyImages, keyFacilities, packingOptions, processSteps } from "../Data";
import organizationSchema from "../Schema/OrganizationSchema";
import SchemaMarkup from "../Components/SchemaMarkup";
import breadcrumbSchema from "../Schema/BreadcrumbSchema";
import aboutPageSchema from "../Schema/AboutPageSchema";

const Infrastructure=()=>{
    useEffect(() => {
                document.title =
                  "Infrastructure & Production Capabilities | Iris Impulse India Pvt. Ltd.";
            
                const metaDesc = document.querySelector("meta[name='description']");
                if (metaDesc) {
                  metaDesc.setAttribute(
                    "content",
                    "Explore Iris Impulse India Pvt. Ltd.'s advanced facilities, cutting-edge technology, and capabilities in mineral processing and export. Contact us for product details today!"
                  );
                }
            
                 const canonical = document.querySelector("link[rel='canonical']");
              if (canonical) {
                canonical.setAttribute("href", "https://irisimpulse.com/about-us/infrastructure");
              }
            
              const ogTitle = document.querySelector("meta[property='og:title']");
              if (ogTitle) {
                ogTitle.setAttribute(
                  "content",
                  "Infrastructure & Production Capabilities | Iris Impulse India Pvt. Ltd."
                );
              }
            
                const ogDesc = document.querySelector("meta[property='og:description']");
              if (ogDesc) {
                ogDesc.setAttribute(
                  "content",
                  "Explore Iris Impulse India Pvt. Ltd.'s advanced facilities, cutting-edge technology, and capabilities in mineral processing and export. Contact us for product details today!"
                );
              }
            
              const ogUrl = document.querySelector("meta[property='og:url']");
              if (ogUrl) {
                ogUrl.setAttribute("content", "https://irisimpulse.com/about-us/infrastructure");
              }
            
                const ogImage = document.querySelector("meta[property='og:image']");
              if (ogImage) {
                ogImage.setAttribute(
                  "content",
                  "https://irisimpulse.com/Images/infrastructure.webp"
                );
              }
            
                const twitterTitle = document.querySelector("meta[name='twitter:title']");
              if (twitterTitle) {
                twitterTitle.setAttribute(
                  "content",
                  "Infrastructure & Production Capabilities | Iris Impulse India Pvt. Ltd."
                );
              }
            
                const twitterDesc = document.querySelector(
                "meta[name='twitter:description']"
              );
              if (twitterDesc) {
                twitterDesc.setAttribute(
                  "content",
                  "Explore Iris Impulse India Pvt. Ltd.'s advanced facilities, cutting-edge technology, and capabilities in mineral processing and export. Contact us for product details today!"
                );
              }
            
                const twitterImage = document.querySelector("meta[name='twitter:image']");
              if (twitterImage) {
                twitterImage.setAttribute(
                  "content",
                  "https://irisimpulse.com/Images/infrastructure.webp"
                );
              }
              }, []);

     const prevRef = useRef(null);
  const nextRef = useRef(null);

  const [activeIndex, setActiveIndex] = useState(0);

  const activeItem =
    efficiencyImages[activeIndex];

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2
    }
  }
};


const cardAnim = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: "easeOut" }
  }
};

const organizationData = organizationSchema();
const breadcrumbData = breadcrumbSchema({
  items: [
    {
      name: "Home",
      url: "https://irisimpulse.com/",
    },
    {
      name: "About Us",
      url: "https://irisimpulse.com/about-us"
    },
    {
      name: "Infrastructure & Capabilities",
    },
  ],
});
  const aboutPageData = aboutPageSchema({
  url: "https://irisimpulse.com/about-us/infrastructure",
  title: "Infrastructure & Production Capabilities | Iris Impulse India Pvt. Ltd.",
  description:
    "Explore Iris Impulse India Pvt. Ltd.'s advanced facilities, cutting-edge technology, and capabilities in mineral processing and export. Contact us for product details today!",
  image: "https://irisimpulse.com/Images/infrastructure.webp",
});
    return(
        <>

      <SchemaMarkup data={organizationData} />
      <SchemaMarkup data={breadcrumbData} />
      <SchemaMarkup data={aboutPageData} />

          <BreadCrumb
  title="Infrastructure & Capabilities" 
  bgImage={bgImg} 
/>

      {/**KEY FACILITIES SNAPSHOT SECTION */}
      <section className="offers-section infrastructure-section">
              <div className="container">
      
        {/* HEADING */}
        <motion.h2
          className="section-heading"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
         Key Facilities Snapshot

        </motion.h2>
      
        {/* TEXT */}
        <motion.p
          className="section-text"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          transition={{ delay: 0.2 }}
          viewport={{ once: true }}
        >
         <b className="bold">Iris Impulse India Pvt. Ltd.</b>, based in Kutch, Gujarat, India, operates with robust mining, processing, and storage capacities to meet global demand. With multiple active mining sites, advanced production plants, and strong logistics support, we ensure consistent quality, large-scale supply, and on-time delivery to industries worldwide.
        </motion.p>
      
        {/* GRID */}
        <motion.div
          className="offers-grid"
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {keyFacilities.map((item) => (
            <motion.div
              className="offer-card"
              key={item.title}
              variants={cardAnim}
            >
              <motion.div
                className="card-inner"
                whileHover={{ y: -8 }}
              >
                <img src={item.icon} alt={`${item.title} | Iris Impulse India Pvt. Ltd.`}></img>
                <h3 className="card-heading">{item.title}</h3>
                <p>{item.description}</p>
              </motion.div>
            </motion.div>
      
          ))}
        </motion.div>
      </div>
      </section>
      


      {/**PROCESS FLOW SECTION */}
      <section className="process-flow-section container">

  {/* TOP CONTENT */}
  <motion.h2
    className="section-heading"
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.2 }}
  >
    Process Flow
  </motion.h2>

  <motion.p
    className="section-text"
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.2 }}
  >
    At <b className="bold">Iris Impulse India Pvt. Ltd.</b>, we follow a well-structured process
    that ensures quality, consistency, and timely delivery. From Mining
    Pit Analysis to minerals extraction, sampling and quality checks at
    every stage are carefully monitored. The materials then go through
    blending, processing, milling, packaging and storage before being
    prepared for dispatch. With efficient logistics and container
    handling at both mines and plant, we make sure our minerals reach
    global markets securely and on time.
  </motion.p>

  <motion.div
    className="process-flow-slider-wrapper"
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.1 }}
  >

    {/* NAVIGATION */}

    <div
      ref={prevRef}
      className="custom-arrow prev-arrow"
    >
      <motion.span
        initial={{ opacity: 0, x: -15 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        whileHover={{
          scale: 1.1,
        }}
        whileTap={{
          scale: 0.92,
        }}
      >
        &#10094;
      </motion.span>
    </div>

    <div
      ref={nextRef}
      className="custom-arrow next-arrow"
    >
      <motion.span
        initial={{ opacity: 0, x: 15 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        whileHover={{
          scale: 1.1,
        }}
        whileTap={{
          scale: 0.92,
        }}
      >
        &#10095;
      </motion.span>
    </div>

    {/* SWIPER */}

    <Swiper
      modules={[Navigation, Pagination]}
      slidesPerView={1}
      loop={true}
      speed={900}
      navigation={{
        prevEl: prevRef.current,
        nextEl: nextRef.current,
      }}
      onBeforeInit={(swiper) => {
        swiper.params.navigation.prevEl =
          prevRef.current;

        swiper.params.navigation.nextEl =
          nextRef.current;
      }}
      pagination={{
        el: ".mining-pagination",
        clickable: true,
      }}
      className="process-flow-slider"
    >

      {processSteps.map((item) => (

        <SwiperSlide key={item.id}>

          <motion.div
            className="process-flow-slide"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >

            {/* IMAGE */}

            <div className="process-flow-image-wrapper">

              <motion.img
                src={item.image}
                alt={`${item.title} | Iris Impulse India Pvt. Ltd.`}
                className="process-flow-image"
                whileHover={{
                  scale: 1.2,
                }}
                transition={{
                  duration: 0.5,
                }}
              />

              {/* CARD */}

              <motion.div
                className="process-flow-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{
                  duration: 0.7,
                  delay: 0.2,
                }}
              >
                <div className="process-flow-row">

                <motion.span
                  className="process-flow-number"
                  whileHover={{
                    scale: 1.08,
                  }}
                >
                  {item.id}
                </motion.span>

                <h3 className="card-heading">
                  {item.title}
                </h3>
                </div>

                <p className="section-text">
                  {item.description}
                </p>

              </motion.div>

            </div>

          </motion.div>

        </SwiperSlide>
      ))}

    </Swiper>

    {/* PAGINATION */}

    <motion.div
      className="mining-pagination"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ delay: 0.4 }}
    />

  </motion.div>

</section>

      {/**SUSTAINABILITY AND EFFICIENCY FEATURES */}
      <section className="mining-cards efficiency-section">

  <div className="container">

    {/* HEADING */}

    <motion.h2
      className="section-heading"
      variants={fadeUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      Sustainability & Efficiency Features
    </motion.h2>

    <motion.div
      className="mining-cards-slider"
      variants={fadeUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.1 }}
    >

      {/* =========================
          IMAGE SLIDER ONLY
      ========================= */}

     <Swiper
        modules={[Autoplay]}
        slidesPerView={1}
        loop={true}
        speed={1200} 
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        onSlideChange={(swiper) => {
          setActiveIndex(swiper.realIndex);
        }}
        className="mining-swiper"
      >

        {efficiencyImages.map((item,i) => (
          <SwiperSlide key={item.id}>

            <div className="mining-slide">

              {/* IMAGE ONLY */}

              <div className="mining-image efficieny-img">

                <motion.img
                  src={item.image}
                  alt={` ${item.title} | Iris Impulse India Pvt. Ltd.`}
                  initial={{ scale: 1.08 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 1 }}
                  whileHover={{
                    scale: 1.03,
                  }}
                />

                <div className="home-csr-caption">
          <p className="section-text">{item.title}</p>
        </div>

              </div>

            </div>

          </SwiperSlide>
        ))}

      </Swiper>

      {/* =========================
          FIXED CONTENT CARD
      ========================= */}

      <motion.div
        className="mining-fixed-card"
        initial={{ opacity: 0, x: 40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{
          duration: 0.8,
        }}
      >

        <AnimatePresence mode="wait">
        <div className="mining-fixed-card-inner">
          <motion.div
            key={activeItem.id}
            initial={{
              opacity: 0,
              y: 20
            }}
            animate={{
              opacity: 1,
              y: 0
            }}
            exit={{
              opacity: 0,
              y: -20
            }}
            transition={{
              duration: 0.45
            }}
          >

            <motion.p
              className="section-text"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.2 }}
            >
              At <b className="bold">Iris Impulse India Pvt. Ltd.</b>, Gandhidham, Kutch,
              Gujarat, India, we integrate sustainability into every
              stage of our operations. From responsible mining practices
              to energy-efficient processing, we ensure that our growth
              aligns with environmental care and community well-being.
              Our focus on efficiency helps us reduce waste, optimize
              resources, and deliver long-term value to global partners.
            </motion.p>

            <div className="sustainability-list">

              <ol>

                {[
                  "Responsible Mining – Eco-conscious extraction with minimal environmental impact.",

                  "Energy Efficiency – Advanced equipment to reduce power consumption.",

                  "Energy Independent – With the entire plant operating on green energy, Iris sets an example by reducing fossil fuel dependence, combating climate change, creating employment opportunities, and providing a sustainable, cost-effective energy alternative.",

                  "Water Conservation – Recycling and optimized water usage.",

                  "Waste Management – Safe disposal and maximum resource recovery.",

                  "Community Commitment – Programs supporting local development and welfare.",

                  "Sustainable Logistics – Reduced emissions through efficient transport.",

                  "Quality with Care – Standards that balance performance and environmental responsibility.",

                  "Employee Safety – Training and safe workplace initiatives.",

                  "Global Responsibility – Aligning with international sustainability goals."

                ].map((item, i) => {

                  const [title, desc] = item.split(" – ");

                  return (
                    <motion.li
                      className="section-text"
                      key={i}
                      initial={{
                        opacity: 0,
                        x: 20,
                      }}
                      animate={{
                        opacity: 1,
                        x: 0,
                      }}
                      transition={{
                        delay: i * 0.06,
                        duration: 0.4,
                      }}
                      whileHover={{
                        x: 4,
                      }}
                    >
                      <strong>{title}</strong> – {desc}
                    </motion.li>
                  );
                })}

              </ol>

            </div>

          </motion.div>
        </div>
        </AnimatePresence>


      </motion.div>

    </motion.div>

  </div>

</section>


    {/**PACKING OPTIONS SECTION */}
    <section className="offers-section packing-section">
              <div className="container">
      
        {/* HEADING */}
        <motion.h2
          className="section-heading"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
      Various Packing Options available are

        </motion.h2>
      
      
        {/* GRID */}
        <motion.div
          className="offers-grid packing-grid"
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {packingOptions.map((item) => (
            
            // ❗ keep your structure intact
            <motion.div
              className="offer-card"
              key={item.title}
              variants={cardAnim}
            >
              <motion.div
                className="packing-card"
              >
                <img src={item.img} alt={`${item.title} | Iris Impulse India Pvt. Ltd.`}></img>
                <div className="packing-content">
                <p className="section-text">{item.title}</p>
                </div>
              </motion.div>
            </motion.div>
      
          ))}
        </motion.div>
      </div>
      </section>
      

           
    {/**CTA SECTION */}
    <Cta/>

    {/**CERTIFICATES SECTION */}
    <Certificates/>

    {/**CONTACT FORM SECTION */}
    <ContactSection />
        </>
    )
}
export default Infrastructure;